import { allGamesReducer, ALL_GAMES_INIT_STATE } from './allGamesReducer';
import { combineReducers } from 'redux';

export const gamesReducer = combineReducers({ allGames: allGamesReducer });

export const GAMES_INITIL_STATE = {
  allGames: ALL_GAMES_INIT_STATE,
};
